import { render, staticRenderFns } from "./SelectProductList.vue?vue&type=template&id=97ada222&scoped=true&"
import script from "./SelectProductList.vue?vue&type=script&lang=js&"
export * from "./SelectProductList.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductList.vue?vue&type=style&index=0&id=97ada222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ada222",
  null
  
)

export default component.exports